import { DeviceType } from "src/globalTypes/device";
import flowioast from "src/utils/flowioast";
import { EwaThunk } from "src/store/types";
import { setLocalStorageLoginToken } from "src/utils/localStorageWorker";
import {
  errorMicrosoftLogin,
  requestMicrosoftLogin,
  successMicrosoftLogin,
} from "../actionCreators/authentication/microsoftLoginCreator";
import * as requests from "../../../requests/login/requestCreators";

const microsoftLogin =
  (code: string, deviceType: DeviceType): EwaThunk =>
  async (dispatch, getState) => {
    const localState = getState().login;

    if (
      localState.googleLoggedIn &&
      localState.user !== null &&
      localState.user !== undefined
    ) {
      return;
    }

    const pcke = sessionStorage.getItem("pkceCodeVerifier");
    if (pcke === null) throw new Error("pkce was not found in session storage");

    const pkce = JSON.parse(pcke);

    dispatch(requestMicrosoftLogin());
    let userDto = localState.user;
    let { isUserAdmin } = localState;

    try {
      if (userDto === undefined || userDto === null) {
        const response = await requests.microsoftLogin(
          pkce.verification,
          code,
          deviceType
        );

        if (response.status === 200) {
          userDto = response.data;

          if (userDto.token) {
            setLocalStorageLoginToken(userDto.token);
          }

          const { data } = await requests.isUserAdmin();
          isUserAdmin = data;
        }
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      if (e.response.data === "Wrong user name") {
        flowioast.error.fromIntlBase("login.google", e);
      }
      dispatch(errorMicrosoftLogin(e.toString()));
    }
    dispatch(successMicrosoftLogin(userDto, isUserAdmin));
  };

export default microsoftLogin;
